import { SearchIndex } from 'emoji-mart';

export function getEmojiData(id: string) {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  return SearchIndex.get(id);
}
